import UserStore from '../components/User/UserStore';
import ComponentMixin from '../../shared/Mixins/ComponentMixin';

export default {
  mixins: [ComponentMixin],

  computed: {
    user () {
      return UserStore.state.user;
    }
  }
};
